import React from 'react';
import { PartnerLinkNotification } from './PartnerLinkNotification';
import { ClientUserMenu, type ClientUserMenuAction } from './ClientUserMenu';

type ClientHomeTopBarProps = {
  handleClickSignOut: () => void;
  clientEmail: string;
  clientProfiles?: ClientProfile[];
  onAcceptPartnerRequest?: (requestingClient: ClientProfile) => void;
  onDeclinePartnerRequest?: (requestingClient: ClientProfile) => void;
  advisorAccountAction?: ClientUserMenuAction;
};

export function ClientHomeTopBar({
  handleClickSignOut,
  clientEmail,
  clientProfiles = [],
  onAcceptPartnerRequest,
  onDeclinePartnerRequest,
  advisorAccountAction,
}: ClientHomeTopBarProps) {
  return (
    <div className="bg-primary-100 top-0 z-50 flex shrink-0 items-center gap-x-4 border-b border-gray-200 px-4 py-1 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <div className="flex h-14 w-full flex-row-reverse items-center gap-3">
        {clientProfiles.length > 0 && onAcceptPartnerRequest && onDeclinePartnerRequest && (
          <PartnerLinkNotification
            clientProfiles={clientProfiles}
            onAcceptRequest={onAcceptPartnerRequest}
            onDeclineRequest={onDeclinePartnerRequest}
          />
        )}

        <ClientUserMenu
          handleClickSignOut={handleClickSignOut}
          clientEmail={clientEmail}
          advisorAccountAction={advisorAccountAction}
        />
      </div>
    </div>
  );
}
